import { useMutation } from '@tanstack/react-query';
import { startTotpRescan, verifyTotpRescan } from '@/api/auth.api';

/**
 * Authenticator re-scan from the account page (FR-220). Failures are shown
 * inline in the open dialog that drives both steps, so neither mutation
 * toasts; success moves the dialog to its next step.
 */
export function useStartTotpRescan() {
  return useMutation({ mutationFn: startTotpRescan });
}

/** Finish a re-scan with the new entry's first code; resolves to the new recovery codes. */
export function useVerifyTotpRescan() {
  return useMutation({ mutationFn: verifyTotpRescan });
}
